export { GetStatusTextPipe } from './get-status-text.pipe';
